<toaster-popup />
<div class="auth-fullpage">
  <div id="logo-container" [@fadeInGlideUp]="authService.animationDuration">
    <app-logo width="217px" height="48px" class="svg-bold"></app-logo>
  </div>

  <div id="component-container" class="position-relative" [@fadeInGlideDown]="authService.animationDuration">
    <c-card id="component-view-port" class="w-30 p-3 position-absolute top-50 start-50 translate-middle-x">
      <c-card-body>
        <c-container>
          <app-form-header
            [parentComponent]="this"
            [icon]="'fa-shield'"
            [iconStyle]="'fa-thin'"
            [title]="'AUTH_MFA_HEADER'"
            [content]="'AUTH_MFA_HEADER_TEXT'"
            [staticColor]="true"
          ></app-form-header>
        </c-container>

        @if (!authService.actionSucceeded(this)) {
          @if (initializing) {
            <div class="text-center py-4">
              <c-spinner color="primary"></c-spinner>
            </div>
          } @else {
            <app-mfa-verification
              #mfaVerification
              [config]="mfaConfig"
              [loading]="loading"
              [showHeader]="false"
              [showCancel]="false"
              [showBack]="isForceMfa"
              [variant]="'page'"
              [startOnVerifyStep]="!isForceMfa"
              [requiresSourceInput]="isForceMfa"
              [showMethodInVerifyStep]="!isForceMfa"
              [codeSentMessage]="getCodeSentMessage()"
              (sendCode)="onSendCode($event)"
              (verifyCode)="onVerifyCode($event)"
              (resendCode)="onResendCode($event)"
              (methodChanged)="onMethodChanged($event)"
              (back)="onBack()"
            />
          }

          <app-alert-message [parentComponent]="this"></app-alert-message>
        }

        @if (authService.actionSucceeded(this)) {
          <app-alert-confirmation
            [parentComponent]="this"
            [message]="'AUTH_MFA_MESSAGE_SUCCESS'"
          ></app-alert-confirmation>
        }
      </c-card-body>
    </c-card>
  </div>
</div>
